// React
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

// Yup validation
import * as Yup from 'yup';
import { useFormik } from 'formik';

// Containers Injection
import { notifyError } from '../../containers/componentsInjection';
import { ReportsInjection } from '../../containers/reportsInjection';

// Utils
import { useLoading } from '../../../../hook/useLoading';
import { createData } from '../../../../utils/createData';
import { APIClient } from '../../../../helpers/api_helper';
import { openPdfWithBase64 } from '../../../../utils/openPdfWithBase64';

// View
import { DeliveryTermPage } from './view';

export const DeliveryTerm = () => {
  const [col1, setcol1] = useState(true);
  const [col2, setcol2] = useState(false);
  const [isOrgRequired, setIsOrgRequired] = useState(true);

  const { sellers, getSellers, organizations, getOrganizations } =
    ReportsInjection();

  const api = new APIClient();
  const history = useHistory();
  const { toggleLoading, setLoading } = useLoading();

  const t_col1 = () => {
    setIsOrgRequired(true);
    setcol1(!col1);
    setcol2(false);
  };

  const t_col2 = () => {
    setIsOrgRequired(false);
    setcol2(!col2);
    setcol1(false);
  };

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      periodStarts: '',
      periodEnds: '',
      sellerInput: '',
      organizationInput: '',
      searchInput: '',
      isOrgRequired: isOrgRequired,
    },
    validationSchema: Yup.object({
      periodStarts: Yup.string().when('isOrgRequired', {
        is: true,
        then: Yup.string().required(),
        otherwise: Yup.string(),
      }),
      periodEnds: Yup.string().when('isOrgRequired', {
        is: true,
        then: Yup.string().required(),
        otherwise: Yup.string(),
      }),
      sellerInput: Yup.object().shape({
        label: Yup.string(),
        value: Yup.string().required(),
      }),
      organizationInput: Yup.object()
        .shape({
          label: Yup.string(),
          value: Yup.string(),
        })
        .when('isOrgRequired', {
          is: true,
          then: Yup.object().shape({
            label: Yup.string(),
            value: Yup.string().required(),
          }),
          otherwise: Yup.object().shape({
            label: Yup.string(),
            value: Yup.string(),
          }),
        }),
      searchInput: Yup.object()
        .shape({
          label: Yup.string(),
          value: Yup.string(),
        })
        .when('isOrgRequired', {
          is: false,
          then: Yup.object().shape({
            label: Yup.string(),
            value: Yup.string().required(),
          }),
          otherwise: Yup.object().shape({
            label: Yup.string(),
            value: Yup.string(),
          }),
        }),
    }),

    onSubmit: (values) => {
      const valuesToSubmit = {
        starts: values.periodStarts || null,
        ends: values.periodEnds || null,
        seller_id: values.sellerInput.value || null,
        organization_id: values.organizationInput.value || null,
        search_id: values.searchInput.value || null,
      };

      toggleLoading();
      api
        .create('/reports/card/delivery-term', valuesToSubmit)
        .then((response) => {
          openPdfWithBase64(
            response.data,
            'Termo de Responsabilidade de Entrega de Cartão'
          );
        })
        .catch((error) => {
          notifyError(error.response.data.messages.error);
        })
        .finally(() => {
          setLoading(false);
        });
    },
  });

  useEffect(() => {
    getSellers();
    getOrganizations();
  }, []);

  return (
    <DeliveryTermPage
      history={history}
      createData={createData}
      validation={validation}
      // Data
      sellers={sellers || []}
      organizations={organizations || []}
      // Accordion
      col1={col1}
      col2={col2}
      t_col1={t_col1}
      t_col2={t_col2}
      setcol2={setcol2}
      setcol1={setcol1}
    />
  );
};
